import React from 'react';
import PropTypes from 'prop-types';

const Radio = ({ color = '', style = {} }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="white"
    style={style}
  >
    <circle
      cx="10"
      cy="10"
      r="9"
      stroke={color || 'var(--SUCCESS_STATUS)'}
      strokeWidth="2"
    />
    <circle cx="10" cy="10" r="6" fill={color || 'var(--SUCCESS_STATUS)'} />
  </svg>
);

Radio.propTypes = {
  color: PropTypes.string,
  style: PropTypes.object,
};

export default Radio;
